import Vue from "vue"
import Vuex from "vuex"
import global from "./modules/global"
import account from "./modules/account"
import auth from "./modules/auth"
import bizes from "./modules/bizes"
import taxes from "./modules/taxes"
import products from "./modules/products"

//accounting
import accounting from "./modules/accounting/accounting"
import transactions from "./modules/accounting/transactions"

//sales
import customers from "./modules/sales/customers"
import estimates from "./modules/sales/estimates"
import invoices from "./modules/sales/invoices"
//purchases
import bills from "./modules/purchases/bills"
import receipts from "./modules/purchases/receipts"
import vendors from "./modules/purchases/vendors"

import reports from "./modules/reports"

//settings
import collaborators from "./modules/collaborators"

import dashboard from "./modules/dashboard"

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    account,
    auth,
    bizes,
    global,
    taxes,
    products,
    customers,
    estimates,
    invoices,
    bills,
    receipts,
    vendors,
    accounting,
    transactions,
    reports,
    collaborators,
    dashboard
  }
})
